import { render } from "./dateOfUse.vue?vue&type=template&id=55630b21&scoped=true"
import script from "./dateOfUse.vue?vue&type=script&lang=js"
export * from "./dateOfUse.vue?vue&type=script&lang=js"

import "./dateOfUse.vue?vue&type=style&index=0&id=55630b21&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55630b21"]])

export default __exports__